
import React from "react";

const Header = () => {
  return (
    <header className="topbar">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-6">
            <a href='/'>
            <img src="images/logo.png" alt="logo" className="logo-img" />
            </a>
          </div>
          <div className="col-6">
            <div className="call-text">
              Call Now: <a href="tel:18005711030">18005711030</a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
